import qr from "qrcode"
export default (amount) => ({
	init(){
		qr.toCanvas(this.$el,`SPD*1.0*ACC:CZ1230300000001373092010*AM:${amount}*CC:CZK*MSG:EDOSUSHI objednávka`)
	}
})

